import * as React from 'react';

export interface AssessmentProps {
    problem_id: number,
    gotoPage: (string) => void
}

export class AssessmentComponent<P, S> extends React.Component<P, S> { 
	displayName="AssessmentComponent<P, S>"
}